import { useMutation, useQueryClient } from 'react-query';

import { PromptTemplateScope } from '../../../../backend/src/prompt-template/dto/prompt-template.constants';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeletePromptTemplate = (
  matterId: string | undefined,
  scope: PromptTemplateScope = PromptTemplateScope.Personal,
) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, templateMatterId = matterId }: { id: string; templateMatterId?: string }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      // Organisation-scoped templates are not tied to a matter.
      const params = new URLSearchParams({ scope });
      if (scope === 'personal' && templateMatterId) params.set('matterId', templateMatterId);
      const res = await fetch(`${APIBaseChronos}/api/prompt-template/${id}?${params}`, fetchConfig);

      if (!res.ok) throw new Error('Deleting prompt template failed');
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.PromptTemplates]);
      },
    },
  );
};
